import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Hide the dev-server "Uncaught runtime errors" overlay for generic cross-origin
// "Script error." events (benign; not shown in production builds).
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (e && typeof e.message === "string" && e.message.indexOf("Script error") !== -1) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
